<div class="business-comp">
    <div class="business-comp-header font-class-one">
        <span><b>Confirm deletion</b></span>
        <a class="close-business-comp" (click)="closeConfimationBox()" >
            <i class="fas fa-times" style="color:white;"></i>
        </a>
        <p class="margin-two"> </p>
    </div>
  
    <div class="business-comp-content-section font-class margin-class-top">
        By removing the client project from this business component, you will lose the connection with
        its business component.
    </div>

    <div class="business-comp-content-section font-class">
        Are you sure you want to remove this client project from business component?
    </div>
    <br />

    <div class="business-comp-content-section " style="flex-direction:column">
        <button type='button' class="btn font-class-two btn-delete" (click)="removeSelectedProject()">
            Remove
        </button>
        <a (click)="closeConfimationBox()" class="btn-back">Go Back</a>
    </div>

</div>
